import { render, staticRenderFns } from "./AppPaginator.vue?vue&type=template&id=3f6d4a2d&scoped=true&"
import script from "./AppPaginator?vue&type=script&lang=js&"
export * from "./AppPaginator?vue&type=script&lang=js&"
import style0 from "./AppPaginator.vue?vue&type=style&index=0&id=3f6d4a2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d4a2d",
  null
  
)

export default component.exports